import React from 'react'
import { Box, Typography } from '@mui/material'
import Image from 'next/image'
import { commify } from 'ethers/lib/utils'
import { useAtomValue } from 'jotai'
import ContractAddress from './ContractAddress'
import CrossChainAmount from './CrossChainAmount'
import CrossChainSteps from './CrossChainSteps'
import TokenLogo from '@/components/common/TokenLogo'
import { TICKERS, TICKERS_MAP_BY_NAME } from '@/constants/token'
import CoingeckoSvg from '@/assets/imgs/coingecko.svg'
import { CHAIN_INFO, SUPPORTED_CHAIN_ID } from '@/constants'
import { useUsdPriceOfToken } from '@/hooks/useUsdPriceOfToken'
import { TickerAtom } from '@/components/common/atoms'

const TokenInfo = () => {
  const tickerName = useAtomValue(TickerAtom)
  const ticker = TICKERS_MAP_BY_NAME[tickerName]

  const { data: prices } = useUsdPriceOfToken(
    TICKERS.filter((ticker) => !!ticker?.coinGeckoId).map((ticker) => ticker.coinGeckoId),
  )
  // console.log('prices: ', prices)

  const price = prices?.[TICKERS_MAP_BY_NAME?.[tickerName]?.coinGeckoId]?.usd

  return (
    <Box sx={{ width: { xs: 'auto', md: 376 } }}>
      <Typography sx={{ fontSize: '30px', fontWeight: 700, lineHeight: 'normal' }}>Token Information</Typography>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mt: 20,
          border: '1px solid rgba(191, 255, 11, 0.20)',
          bgcolor: '#111303',
          p: 16,
        }}
      >
        <TokenLogo src={ticker.logoSrcSet?.erc || ticker.logoSrcSet.brc} size={48} alt={ticker.name} />
        <Typography
          sx={{
            fontSize: '32px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '150%',
            ml: 16,
          }}
        >
          {ticker.name}
        </Typography>
        <Typography
          sx={{
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '150%',
            ml: 'auto',
          }}
        >
          ${price ? commify(Number(price).toFixed(8)) : '-'}
        </Typography>
        <Image style={{ marginLeft: '8px' }} src={CoingeckoSvg} width={20} height={20} alt="coingecko" />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', mt: 24 }}>
        <Typography
          sx={{
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
          }}
        >
          Existing cross-chain amount
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(191, 255, 11, 0.20)',
            px: 8,
            ml: 8,

            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '150%',
          }}
        >
          BRC 20
        </Box>
      </Box>

      <CrossChainAmount />

      {Object.keys(ticker.erc20Tokens)
        .filter((key) => SUPPORTED_CHAIN_ID.includes(Number(key)))
        .map((key) => (
          <ContractAddress
            key={key}
            title={`${CHAIN_INFO[key].abbreviation} contract address`}
            address={ticker.erc20Tokens[key].address}
            chainId={Number(key)}
          />
        ))}

      <CrossChainSteps />
    </Box>
  )
}

export default TokenInfo
